import PendoButton from '../../../components/button/pendo-button.vue.js';
import PendoInputNumber from '../../../components/input-number/pendo-input-number.vue.js';
import PendoLoadingIndicator from '../../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoModal from '../../../components/modal/pendo-modal.vue.js';

var script = {
  name: 'GuideAlertSettingsModal',
  components: {
    PendoButton,
    PendoInputNumber,
    PendoLoadingIndicator,
    PendoModal
  },
  props: {
    guideSeenTimeout: {
      type: Number,
      default: 10000
    },
    guideAlertsAggStatus: {
      type: String,
      required: true
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeoutThreshold: 10
    };
  },
  computed: {
    isLoading() {
      return this.guideAlertsAggStatus === 'loading';
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.timeoutThreshold = this.guideSeenTimeout / 1000;
      }
    }
  },
  created() {
    this.timeoutThreshold = this.guideSeenTimeout / 1000;
  },
  methods: {
    onSave() {
      this.$emit('update-guide-seen-timeout', this.timeoutThreshold * 1000);
    },
    closeModal() {
      this.$emit('close');
    }
  }
};

export { script as default };
//# sourceMappingURL=guide-alert-settings-modal.vue2.js.map
